import axios from 'axios';
import config from 'config/config';

// Dedicated CoreSkills axios client. Do NOT append /api to baseURL.
export const coreSkillsApi = axios.create({
  baseURL: config.CORESKILLS_API_URL,
});

coreSkillsApi.interceptors.request.use((cfg) => {
  if (cfg.headers) {
    // HTTP header names are case-insensitive
    cfg.headers['X-API-Key'] = process.env.REACT_APP_CORESKILLS_API_KEY as string;
  }
  return cfg;
});

export default coreSkillsApi;
